import { Directive, ElementRef, AfterViewInit, OnDestroy, Renderer2, OnInit } from '@angular/core';
import { FocusMonitor } from '@angular/cdk/a11y';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[sdComponentControlFocus],[sdCCF],[formControlName],[ngrxFormControlState]'
})
export class ComponentControlFocusDirective implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private readonly el: ElementRef,
    private readonly focusMonitor: FocusMonitor,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    const { el } = this;
    this.attrTabindex();
    this.focusMonitor
      .monitor(el)
      .pipe(filter(origin => origin === 'program'))
      .subscribe(() => this.focusInnerControl());
  }
  ngOnDestroy() {
    this.focusMonitor.stopMonitoring(this.el);
  }

  // find and focus inner form control
  private focusInnerControl() {
    const { nativeElement } = this.el;
    const input = nativeElement.querySelector('input');
    if (input) {
      input.focus();
    }
    // TODO: queires for textarea/select/etc.-controls
  }

  // make sure element has 'tabindex' attr to facilitate programmatic focus
  private attrTabindex() {
    const { nativeElement } = this.el;

    let tabindex = nativeElement.attributes['tabindex'];
    if (!tabindex) {
      const tag = nativeElement.localName;
      const isSdComponent = tag.startsWith('sd');
      tabindex = isSdComponent ? '-1' : '0';

      this.renderer.setAttribute(nativeElement, 'tabindex', tabindex);
    }
  }
}
